const isZero = (answer: string): boolean => answer.toString() === '0';

export default isZero;
